import { useQuery } from "@tanstack/react-query";
import { useProductionService } from "../services/production";

export function useProductionMachineDetail(machine: string | undefined, days: number = 30) {
  const service = useProductionService();
  return useQuery({
    queryKey: ["production-machine-detail", machine, days],
    queryFn: () => {
      if (!machine) throw new Error("machine required");
      return service.getMachineDetail(machine, days);
    },
    enabled: !!machine,
    staleTime: 5 * 60_000,
    refetchInterval: 10 * 60_000,
  });
}
